import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Who We Are`}</h2>
    <ProjectCard title="Leo-kun" link="https://squishmallows.com/product/leonard/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
      <img className="center-cropped" src="https://i.ibb.co/KqPg3Jn/leo-kun.jpg" alt="Leo-kun" width="256" />
      <p>{`Meet Leonard the lion! Have you ever met a lion who didn't eat meat? Meet Leonard, he's a vegetarian! He loves lentils, lasagna, and learning how to code. Leonard loves naps like his older brother Richard and is helping create their website – the lion brothers! He is the younger brother of Richie-kun.`}</p>
    </ProjectCard>
    <ProjectCard title="Richie-kun" link="https://squishmallows.com/product/richard/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
      <img src="https://i.ibb.co/bbN6X5W/richie-kun.jpg" alt="Richie-kun" width="256" />
      <p>{`Richard spends his days napping and his nights working as a security guard. His favorite color is orange and even though helooks tough, this lion is a big softy. He is the big brother of Leo-kun.`}</p>
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      